export const limitationTypes = {
  none: 1,
  specificAccounts: 2,
  group: 4,
  childAccounts: 5,
  ownAccount: 6,
  inheritedGroup: 7,
};
